import { keys } from 'lodash';
import { Duration } from 'moment';
import { AuthorizerCallback } from 'pusher-js';
import { logger } from 'services';
import { PusherApi } from './http';

export class BatchAuthorizer {
  private socketId: string;

  private delay: number;

  private requests: Record<string, AuthorizerCallback>;

  private timer?: number;

  constructor(socketId: string, delay: Duration) {
    this.socketId = socketId;
    this.delay = delay.asMilliseconds();
    this.requests = {};
  }

  public add = (channelName: string, callback: AuthorizerCallback) => {
    this.requests[channelName] = callback;
    if (this.timer == null) {
      this.timer = window.setTimeout(() => {
        this.execute();
        this.timer = undefined;
      }, this.delay);
    }
  };

  private execute = async () => {
    const { socketId, requests } = this;

    this.requests = {};
    const channelNames = keys(requests);
    const request = { socketId, channelNames };

    logger.debug('making batch authorize request', request);
    try {
      const responses = await PusherApi.authorize(request);

      channelNames.forEach((key) => {
        const response = responses[key] ?? {
          status: 404,
          error: { message: 'Not found' },
        };
        const callback = requests[key];

        if (response.status === 200) {
          callback(null, response.data);
        } else {
          callback(new Error(response.error.message), { auth: '' });
        }
      });
    } catch (error) {
      logger.error('failed to authorize channels', {
        request,
        error: error as Error,
      });
      channelNames.forEach((key) =>
        requests[key](error as Error, { auth: '' }),
      );
    }
  };
}
